import React, { useState, useEffect } from 'react';
import { Grid, Box, Tabs, Tab } from '@mui/material';
import { useDispatch } from 'react-redux';
import PageHeaderLayout from '../../components/Layout/PageHeaderLayout';
import ImageUpload from './ImageUpload';
import ImageList from './ImageList';
import { MediaServices } from './MediaServices';
import { fileServices } from './FileManager/fileServices';
import Swal from 'sweetalert2';

const ImagePage = () => {
    const menuDispatch = useDispatch();
    const [folder, setFolder] = useState(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'media-image'
        });
    }, [menuDispatch]);

    const handleTabChange = (event, newValue) => {
        setFolder(newValue);
    };

    const handleUploadSuccess = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    const [folderList, setFolderList] = useState([]);

    const fetchFolder = async() => {
        try {
            const response = await fileServices.fetchAllAwsFolders();
//             {
//     "success": 1,
//     "data": {
//         "prefix": "staging/",
//         "folders": [
//             "banner",
//             "booking-payment",
//             "brands",
//             "category",
//             "chatImages",
//             "customer-app",
//             "expert-gallery",
//             "expert-wallet",
//             "kyc",
//             "pdf",
//             "profile",
//             "sdui",
//             "service",
//             "storefront-gallery",
//             "storefront-logo",
//             "subcategory",
//             "undefined",
//             "whatsapp"
//         ]
//     }
// }
            if(response.success == '1'){
                setFolderList(response.data.folders);
            } else if(response.success == '0'){
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.message || 'Failed to fetch folders. Please try again later.',
                });
            }
        } catch (error) {
            console.error('Error fetching folders:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch folders. Please try again later.',
            });
         }
    }

    useEffect(() => {
        fetchFolder();
     }, []);

    return (
        <>
            <PageHeaderLayout headerTitle={'Image Management'}></PageHeaderLayout>

            <Grid container spacing={2} sx={{ mt: 1 }}>
                {/* Upload Section */}
                <Grid item xs={12} md={5}>
                    <ImageUpload onUploadSuccess={handleUploadSuccess} folderList={folderList} />
                </Grid>
            </Grid>
        </>
    );
};

export default ImagePage;
